module.exports = __webpack_public_path__ + "static/media/furnace.1b333cc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/furnace.jpg
// module id = 564
// module chunks = 0